// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__WJEZ4","actions":"style_actions__WOmFF","actions_btn":"style_actions_btn__COQvO"};